<div class="body">
    <div class="col-12 pt-4" *ngIf="formulaire">
        <form [formGroup]="formulaire">
                <h4 class="ml-2 pt-3">E - Les aides apportées par l'association</h4>
                <h5 class="mt-4 ml-2">E.1 - Les entretiens réalisés selon les thématiques dominantes</h5>
                <div class="card-header text-muted">
                    <i>Indiquer le nombre d'entretiens réalisés par l'association durant l'année selon les thématiques dominantes<br>
                       Pour les entretiens qui ont porté sur plusieurs thématiques, comptabiliser uniquement la thématique qui a dominé
                    </i>
                </div>
                <fieldset class="ml-2 mr-2 pt-2">
                <div class="card rounded bg-light shadow" style="border-width:3px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-E1" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th class="text-center align-middle">Thématiques dominantes</th>
                                        <th class="text-center align-middle">Nombre d'entretiens réalisés</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Dominante psychologique</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeEntretPsy" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Dominante juridique</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeEntretJur" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Dominante sociale</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeEntretSoc" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Dominante écoute et soutien</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeEntretEcout" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Autre<br><br>
                                            <bis-string-input [rootForm]="formulaire" label="eeEntretAutrDet" longueurMax=150>
                                            </bis-string-input>
                                            <bis-affiche-alertes labelAlerte='alertE3'></bis-affiche-alertes>
                                        </td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeEntretAutr" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right align-middle pl-2" style="width: 50%">
                                            <b> Total des entretiens réalisés</b>
                                            <span *ngIf="modeRendu.enModeSaisie$ | async">
                                                <button class="btn-info ml-1 mr-2" title="Calcul automatique du total à partir des données ventilées"
                                                    (click)="calculTotalTableauE1()">
                                                    <b><i>Calcul automatique</i></b>
                                                </button>
                                            </span>
                                        </td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeEntretTot" 
                                                classeSupplementaire="integer-input-total text-right" [max]="999999" libelle="vide" [erreursCroisees]="['ctrlE1']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlE1">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertE1'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                </fieldset>

                <div style="page-break-before: always"></div>

                <h5 class="mt-5 ml-2">E.2 - Les diligences</h5>
                <div class="card-header text-muted">
                    <i>Indiquer le nombre de diligences effectuées par l'association durant l'année vers les dispositifs ou institutions indiqués
                    </i>
                </div>
                <fieldset class="ml-2 mr-2 pt-2">
                <div class="card rounded bg-light shadow" style="border-width:3px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-E2" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th class="text-center align-middle">Diligences auprès de</th>
                                        <th class="text-center align-middle">Nombre de diligences effectuées<br> (y compris pour TGD et BAR)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">La juridiction (sauf CIVI)</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliJur" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">La CIVI</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliCivi" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Les fonds de garantie</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliFondGaran" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Le service d'aide au recouvrement des victimes d'infraction (SARVI)</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliSarvi" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Le SPIP, les services pénitentiaires</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliPenit" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">La police, la gendarmerie</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliPolgend" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Un avocat</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliAvoc" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Un commissaire de justice (ex Huissier)</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliHuis" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Les organismes sociaux (la sécurité sociale, la CAF…)</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliOrgaSoc" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Les mairies, collectivités locales, CCAS</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliColter" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">La préfecture</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliPref" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Un organisme de logement</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliOrgaLogt" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Un lieu d'hébergement</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliHebgt" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Les services médicaux et hospitaliers</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliHosto" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Une autre association</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliAsso" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Les assurances</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliAssur" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Les services d'accès au droit hors France services (point justice, maison de justice et du droit…)</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliSad" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Les France services</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliFrserv" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Autres dispositifs ou institutions<br><br>
                                            <bis-string-input [rootForm]="formulaire" label="eeDiliAutrDet" longueurMax=150>
                                            </bis-string-input>
                                            <bis-affiche-alertes labelAlerte='alertE4'></bis-affiche-alertes>
                                        </td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliAutr" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right align-middle pl-2" style="width: 50%">
                                            <b> Total des diligences effectuées</b>
                                            <span *ngIf="modeRendu.enModeSaisie$ | async">
                                                <button class="btn-info ml-1 mr-2" title="Calcul automatique du total à partir des données ventilées"
                                                    (click)="calculTotalTableauE2()">
                                                    <b><i>Calcul automatique</i></b>
                                                </button>
                                            </span>
                                        </td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliTot" 
                                                classeSupplementaire="integer-input-total text-right" [max]="999999" libelle="vide" [erreursCroisees]="['ctrlE2']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlE2">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertE2'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                </fieldset>

                <div style="page-break-before: always"></div>

                <h5 class="mt-5 ml-2">E.3 - Zoom sur les diligences pour les TGD et les BAR</h5>
                <fieldset class="ml-2 mr-2 pt-2">
                <div class="card rounded bg-light shadow" style="border-width:3px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-E3" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th class="text-center align-middle">Diligences effectuées dans le cadre</th>
                                        <th class="text-center align-middle">Nombre de diligences effectuées</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-right align-middle pl-2" style="width: 50%">d'un TGD</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliTgd" 
                                                classeSupplementaire="text-right" [max]="99999" libelle="vide" [erreursCroisees]="['ctrlE3']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlE3">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right align-middle pl-2" style="width: 50%">d'un BAR</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeDiliBar" 
                                                classeSupplementaire="text-right" [max]="99999" libelle="vide" [erreursCroisees]="['ctrlE4']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlE4">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                </fieldset>

                <h5 class="mt-5 ml-2">E.4 - Les aides auprès de la CIVI et du SARVI</h5>
                <div class="card-header text-muted">
                    <i>Indiquer le nombre de personnes reçues durant l'année pour une aide concernant la CIVI et le SARVI
                    </i>
                </div>
                <fieldset class="ml-2 mr-2 pt-2 pb-3">
                <div class="card rounded bg-light shadow" style="border-width:3px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-E3" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th class="text-center align-middle">Type d'aide apportée</th>
                                        <th class="text-center align-middle">Nombre de personnes reçues</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Aide à l'établissement de la requête devant la CIVI pour des dommages corporels et aux biens (706-3, 706-14 et 706-14-1 du CPP)</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeAideCivi" 
                                                classeSupplementaire="text-right" [max]="99999" libelle="vide" [erreursCroisees]="['ctrlE5']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlE5">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 50%">Aide à la constitution du dossier pour le SARVI</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="eeAideSarvi" 
                                                classeSupplementaire="text-right" [max]="99999" libelle="vide" [erreursCroisees]="['ctrlE6']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlE6">
                                            </bis-affiche-erreurs-croisees>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</div>

